import { Badge } from "@simplicity/ui";
import { createElement, type ReactElement } from "react";

/**
 * Variant lookup for run-status strings (export-definition runs, transform runs, etc.).
 * Falls back to `"secondary"` for unknown statuses. Defined as a top-level constant so
 * future consumers can extend or override without re-declaring inside a component.
 */
export const RUN_STATUS_VARIANT: Record<
  string,
  "success" | "destructive" | "secondary" | "warning"
> = {
  completed: "success",
  failed: "destructive",
  running: "warning",
};

/**
 * Renders a `<Badge>` styled by `RUN_STATUS_VARIANT[status]`, so every surface showing a run status
 * (transform runs, scheduled queries, ad-hoc triggers) shares one color treatment. Written as a
 * `createElement` call rather than JSX purely to keep this file `.ts` — functionally identical.
 */
export function ExportRunStatusBadge({ status }: { status: string }): ReactElement {
  const variant = RUN_STATUS_VARIANT[status] ?? "secondary";
  return createElement(Badge, { variant }, status);
}
